import { Area } from "../Area/Area";
import { DirectionsService } from "../../utilities/DirectionsService/DirectionsService";
import { MapQuestDirectionsService } from '../../utilities/MapQuest/DirectionsServiceMapQuest';
import { VehicleReservation } from "../VehicleReservation/VehicleReservation";
import { GroupTripsByHour } from "../../utilities/TripGroup/GroupTripsByHour";
import * as moment from 'moment';
import { UnitConverter } from "../../utilities/unit-converter/UnitConverter";
import { AreaLegMapping } from "../AreaLegMapping/AreaLegMapping";
import { ReportLine } from "../TripReport/TripReport";
import { DirectionOptions } from "../DirectionOptions/DirectionOptions";
import { Vehicle } from "../Vehicle/Vehicle";
import * as uniqid from 'uniqid';
import { SettingValues } from "../../admin-dashboard/settings/SettingValues";
import { MainService } from "../../services/optimizer-service/optimizer.service";
import { DateConstants } from "../../utilities/WeekSchedule/DateConstants";
import { DropOff } from "../DropOff/DropOff";
import { CONSTANTS } from "../../utilities/Constants";
export class Trip {

    color: string;
    markerPng: string;
    reportid: string;
    id: string;
    cumulative: boolean = false;
    providerid: number;
    earnings: number;
    expenses: number;
    driverEarnings: number;
    state: string = 'CREATED';
    slotTime: Date;
    slotid: String;
    published: boolean = false;
    pickupType: string;
    dropOffType: String = "MANY";
    startTime: Date = null;
    endTime: Date = null;
    companyName: String;
    metadata: any;
    companyid: number;
    locationid: number;
    source: Area;
    driverCreated: boolean = false;
    customerCreated: boolean = false;
    destination: Area;
    destinationid;
    destinationName: String;
    areas: Array<Area>;
    droppedOff: Array<DropOff> = [];
    centralPoint: Area;
    time: number = 0;
    dropOffDuration: number = 0;
    loadTime: number = 0;
    distance: number = 0;
    dropOffDistance: number = 0;
    fuel: number = 0;
    snapShotTime: number = 0;
    directions: any;
    vehicleReservation: VehicleReservation;
    passengers: Array<any>;
    subTrips: Map<string, Trip>
    legs: Array<any> = [];
    maxCapacity = 29;
    reportLines: Array<ReportLine> = [];
    currentLegIndex = 0;
    reportDate: Date;
    loadedPassengers: Array<Area> = [];
    overrideDelivery: boolean = false;
    rating?: {
        customerid: any,
        name: any,
        rating: number;
        driver: number;
        recommend: number;
        comment?: string;
    };
    /** Email of the user (customer or admin) who created the order. Populated from backend. */
    createdByEmail?: string;
    /** Email of the user who last modified the trip. Populated from backend. */
    lastModifiedByEmail?: string;
    customerid?: number | string | null;
    savedid?: number | string | null;
    /** Snapshot of auto-discount applied at trip create (null/undefined if none). */
    customerDiscount?: {
        discount_type: 'percentage' | 'flat' | string;
        discount_value: number;
        original_amount?: number;
        discounted_amount?: number;
        discount_amount?: number;
    } | null;

    constructor(source: Area, destination: Area, areas: Array<Area>, pickupType) {
        this.id = uniqid().toUpperCase(); //+ "-" + shortid.generate().toUpperCase();
        this.source = source;
        this.destination = destination;
        this.areas = areas;
        this.passengers = this.getTotalPassengers();
        this.vehicleReservation = null;
        if (pickupType) {
            this.pickupType = pickupType;
        } else {
            this.pickupType = CONSTANTS.PICKUP_TYPE_DEFAULT;
        }
    }

    public async reload(main: MainService, excludeList: Array<string> = []) {
        var tripResponse: any = await main.getTrip(this.id);
        var trip = Trip.createTripFromRawTripData(tripResponse.data);
        Object.keys(trip).forEach(key => {
            var exclude = excludeList.find(prop => prop == key);
            if (!exclude) {
                this[key] = trip[key];
            }
        });
    }

    static getSourceLabel(trip: Trip) {
        if (trip) {
            if (trip.pickupType == CONSTANTS.PICKUP_TYPE_HOME) {
                if (!trip.destinationName) {
                    return trip.source.address;
                }
                return trip.destinationName;
            } else {
                return trip.source.address
            }
        }
        return "";
    }

    static getDestinationLabel(trip: Trip) {
        if (trip) {
            if (trip.pickupType == CONSTANTS.PICKUP_TYPE_HOME) {
                return trip.destination.address;
            } else {
                return trip.destinationName
            }
        }
        return "";
    }

    static getPickupType(trip: Trip) {
        if (trip.pickupType == CONSTANTS.PICKUP_TYPE_WORK) {
            if (trip.dropOffType == CONSTANTS.DROPOFF_ONE) {
                return "Point To Point";
            } else {
                return 'Work Pickup';
            }
        } else {
            if (trip.companyid == -1 || trip.locationid == -1) {
                return "Client Service";
            }
            return 'Home Pickup';
        }
    }

    static getPointToPointType(trip:Trip){
        if(Trip.getPickupTypeCode(trip) == CONSTANTS.PICKUP_TYPE_POINT_TO_POINT && trip.source.centralPoint){
            return CONSTANTS.REVERSE_POINT_TO_POINT;
        }else if(Trip.getPickupTypeCode(trip) == CONSTANTS.PICKUP_TYPE_POINT_TO_POINT && !trip.source.centralPoint){
            return CONSTANTS.PICKUP_TYPE_POINT_TO_POINT;
        }else{
            return null;
        }
    }

    static getPickupTypeCode(trip: Trip) {
        if (trip.pickupType == CONSTANTS.PICKUP_TYPE_WORK) {
            if (trip.dropOffType == CONSTANTS.DROPOFF_ONE) {
                return CONSTANTS.PICKUP_TYPE_POINT_TO_POINT;
            } else {
                return CONSTANTS.PICKUP_TYPE_WORK;
            }
        } else {
            if (trip.companyid == -1 || trip.locationid == -1) {
                return CONSTANTS.PICKUP_TYPE_ADHOC;
            }
            return CONSTANTS.PICKUP_TYPE_HOME;
        }
    }


    public static createSubTripKey(time: moment.Moment): string {

        return time.toLocaleString();
    }

    getVehicle() {
        if (this.vehicleReservation) {
            return this.vehicleReservation.vehicle;
        } else {
            return null;
        }
    }

    nextLeg() {
        if ((this.currentLegIndex + 1) == this.legs.length) {
            this.currentLegIndex = 0;
        } else {
            this.currentLegIndex += 1;
        }
    }

    prevLeg() {

        if ((this.currentLegIndex - 1) < 0) {
            this.currentLegIndex = (this.legs.length - 1);
        } else {

            this.currentLegIndex -= 1;
        }
    }


    createSubTripsByTime() {
        this.subTrips = new GroupTripsByHour().group(this);
    }

    getTripTime() {
        return this.time;
    }

    public calculateEarnings() {
        return ((this.distance / 1000) * 25) * this.areas.length;
    }

    async calculateDirections(service: MainService) {
        try {
            var result = await service.getDirections(this);
            if (!result.status) {
                throw new Error(result.message);
            } else {
                this.time = result.totalDuration;
                if (this.vehicleReservation) {
                    var tripWait = this.vehicleReservation.tripsAndWaitTimes.find(t => t.tripId == this.id);
                    if (tripWait) {
                        tripWait.tripTime = this.time;
                    }
                }
                this.distance = result.totalDistance;
                this.legs = result.legs;
                try {
                    let lastLegIndex = (this.legs[0].routes[0].legs.length - 1);
                    let finalDistance = this.legs[0].routes[0].legs[lastLegIndex].distance.value;
                    let finalDuration = this.legs[0].routes[0].legs[lastLegIndex].duration.value;
                    this.dropOffDistance = (this.distance - finalDistance);
                    this.dropOffDuration = (this.time - finalDuration);
                } catch (e) {
                    console.log(e);
                }
            }
        } catch (e) {
            console.log(e);
            throw new Error(`An error occured while fetching the directions. This may be due to network or internet issues`);
        }
    }

    getDropOffDurationAndDistance() {
        try {
            let lastLegIndex = (this.legs[0].routes[0].legs.length - 1)
            let finalDistance = this.legs[0].routes[0].legs[lastLegIndex].distance.value;
            let finalDuration = this.legs[0].routes[0].legs[lastLegIndex].duration.value;
            this.dropOffDistance = (this.distance - finalDistance);
            this.dropOffDuration = (this.time - finalDuration);

            return {
                distance: this.dropOffDistance,
                duration: this.dropOffDuration > 0 ? (this.dropOffDuration / 60).toFixed(0) : 0
            }
        } catch (e) {
            console.log(e);
            return {
                distance: 0,
                duration: 0
            }
        }
    }

    getCentralPointLatLng() {

        return this.centralPoint.getLatLng();
    }

    getTotalPassengers() {

        var persons = [];
        if (this.areas != null) {
            this.areas.forEach(area => {

                area.destinations.forEach(destination => {

                    persons.push(destination.person);
                })
            })
            return persons;
        } else {
            return [];
        }

    }

    getDirectionsGoogle(directionsService: DirectionsService, options: DirectionOptions): Promise<Trip> {

        return new Promise((resolve, reject) => {

            setTimeout(() => {
                directionsService.calculateDirections(this, options).then(res => {
                    resolve(this);
                }).catch(res => {
                    if (res.status == "OVER_QUERY_LIMIT") {
                        console.timeEnd("quota");
                        console.time("quota");
                        console.log("!!!!!SLOW DOWN!!!!");
                        setTimeout(() => {
                            this.getDirectionsGoogle(directionsService, options).then(results => {
                                resolve(this);
                            }).catch(e => {
                                reject(e);
                            })
                        }, 3000);
                    } else {
                        reject(res.status);
                    }
                })
            }, 500);
        });
    }

    getDirections(directionsService: MapQuestDirectionsService, options: DirectionOptions): Promise<Trip> {

        return new Promise((resolve, reject) => {
            directionsService.calculateDirections(this, options).then(res => {
                //this.directions = res;
                resolve(this);
            }).catch(e => {
                reject(e);
            })
        });
    }

    public getHour() {
        return moment(this.slotTime).format('hh:mm A');
    }

    public getDayString(format) {
        return moment(this.slotTime).format(format);
    }


    /**
     * Return the date the trip is assigned to as a moment.js object
     * @returns 
     */
    getTripSlotTimeMoment() {
        return moment(this.slotTime);
    }

    /**
     * Return the date the trip is assigned to as a string
     * @returns 
     */
    public getTripSlotTime() {
        var time = this.slotTime.toString();
        return time;
    }

    /**Get the uniqe spread of time slots based on the reportDate of each trip*/
    static getDistinctTimeSlots(trips: Array<Trip>): Array<moment.Moment> {
        var map = {};
        var list: Array<moment.Moment> = [];
        var Key = null;
        trips.forEach(t => {
            Key = moment(t.slotTime).format(DateConstants.standard24hHrDateTimeFormat);
            Key = map[Key];
            if (!Key) {
                Key = moment(t.slotTime).format(DateConstants.standard24hHrDateTimeFormat)
                map[Key] = Key;
                list.push(moment(t.slotTime));
            }
        });
        return list;
    }


    /**
     * Return the depart time of a trip as a formatted string
     * @returns 
     */
    public getDepartTime(format: string = null) {
        if (!format) {
            var m = this.getDepartTimeRaw();
            return m.format('hh:mm A');
        } else {
            var m = this.getDepartTimeRaw();
            return m.format(format);
        }
    }

    /**
     * Get the depart time of a trip as a momnet.js object
     * @returns 
     */
    public getDepartTimeRaw() {
        var m = this.vehicleReservation.getTripDepartTime(this);
        return m;
    }

    /**
     * Gets the return time of a trip as a formatted string
     * @returns 
     */
    public getArrivalTime(format: string = 'hh:mm A') {
        var m = this.vehicleReservation.getTripReturnTime(this);
        return m.format(format);
    }

    /**
     * 
     * @returns Gets the return time of a trip as a moment.js object
     */
    public getArrivalTimeRaw() {
        var m = this.vehicleReservation.getTripReturnTime(this);
        return m;
    }


    /**
     * Gets the duration of a trip as text e.g 1h 30m
     * @returns 
     */
    public getDuration() {

        var mins = new UnitConverter().secondToMinute(this.time);
        if (mins > 60) {
            var hours = new UnitConverter().minuteToHours(mins);
            var decimalPortion = hours % 1;
            return Math.floor(hours) + "h " + Math.floor(decimalPortion * 60) + "m"
        } else {
            return Math.floor(mins) + "m";
        }
    }

    getEndTimeString() {
        try {
            if (this.state == CONSTANTS.TRIP_STARTED || !this.endTime) {
                return 'In Progress';
            }
            return moment(this.endTime).format(DateConstants.shortDateTimeFormate);
        } catch (e) {
            if (this.state == CONSTANTS.TRIP_STARTED) {
                return 'In Progress';
            }
            return 'N/A';

        }
    }

    getActualDuration() {
        try {
            if (this.endTime && this.startTime) {
                var start = moment(this.startTime);
                var end = moment(this.endTime);
                var diff = end.diff(start, 'seconds');
                return diff;
            } else {
                0;
            }
        } catch (e) {
            return 0;
        }
    }

    public calculateDropProperties() {
        var counter = 0;
        var mapping = this.getAreaLegMapping();
        var perviousTime: Date;
        var previousDuration: number = 0;
        var previousDistance: number = 0;

        this.legs.forEach(leg => {
            leg.routes["0"].waypoint_order.forEach(index => {
                var currentLeg = leg.routes["0"].legs[index];
                var currentLegMapping = mapping.find(x => x.getLeg() == currentLeg);
                var area = currentLegMapping.getArea();

                area.totalDuration = 0;
                area.totalDistance = 0;

                var durationOfLegInSec = currentLeg.duration.value;

                if (counter == 0) {
                    area.dropOffTime = moment(this.getDepartTimeRaw().toString()).add(durationOfLegInSec, 's').toDate();
                } else {
                    area.dropOffTime = moment(perviousTime).add(durationOfLegInSec, 's').toDate();
                }

                area.durationStringFromLastPoint = currentLeg.duration.text;
                area.durationFromLastPoint = currentLeg.duration.value;
                area.distaneStringFromLastPoint = currentLeg.distance.text;
                area.distanceFromLastPoint = currentLeg.distance.value;



                if (this.pickupType == CONSTANTS.PICKUP_TYPE_WORK) {
                    area.totalDistance += previousDistance + currentLeg.distance.value;
                } else {
                    area.totalDistance = currentLeg.distance.value;
                }
                if (this.pickupType == CONSTANTS.PICKUP_TYPE_WORK) {
                    area.totalDuration += previousDuration + currentLeg.duration.value;
                } else {
                    area.totalDuration = this.getArrivalTimeRaw().diff(area.dropOffTime, 's');
                }
                var converter = new UnitConverter();
                area.totalDurationString = converter.secondsToFormattedTime(area.totalDuration, true, true);
                area.totalDistanceString = Math.round(area.totalDistance) + "";
                previousDistance = area.totalDistance;
                previousDuration = area.totalDuration;

                perviousTime = area.dropOffTime;

                counter++;
            });
        });
    }

    public getUserReportLines(userid: number): Array<ReportLine> {
        return this.getTripReportDetails().filter(x => x.UserId == userid);
    }

    public getTripReportDetails(): Array<ReportLine> {


        var mapping = this.getAreaLegMapping();
        this.calculateDropProperties();
        var reportLines = new Array<ReportLine>();

        mapping.forEach(m => {
            var a = m.getArea();
            var reportLine = new ReportLine();
            reportLine.tripId = this.id;
            reportLine.status = this.state;
            reportLine.PickupDay = this.pickupType == CONSTANTS.PICKUP_TYPE_WORK ? this.getDepartTime('dddd MMMM DD') : moment(a.dropOffTime).format('dddd MMMM DD');
            reportLine.PickupHour = this.pickupType == CONSTANTS.PICKUP_TYPE_WORK ? this.getDepartTime('hh:mm A') : moment(a.dropOffTime).format('hh:mm A');
            reportLine.PickupTime = this.pickupType == CONSTANTS.PICKUP_TYPE_WORK ? this.getDepartTime('dddd MMMM DD YYYY hh:mm A') : moment(a.dropOffTime).format('dddd MMMM DD YYYY hh:mm A');
            reportLine.PickupType = this.pickupType;
            reportLine.PickupLocation = this.source.address;
            reportLine.VehicleMake = this.vehicleReservation.vehicle.make;
            reportLine.VehicleModel = this.vehicleReservation.vehicle.model;
            reportLine.UserId = a.userid;
            reportLine.VehicleYear = this.vehicleReservation.vehicle.year.toString();
            reportLine.VehicleCapacity = this.vehicleReservation.vehicle.capacity.toString();
            reportLine.Driver = this.vehicleReservation.vehicle.make == "CONTRACTED" ? "Contractor" : this.vehicleReservation.vehicle.driverfirstname + " " + this.vehicleReservation.vehicle.driverlastname;
            reportLine.Passenger = a.destinations[0].person;
            reportLine.Distance = a.totalDistanceString;
            reportLine.DistanceFromSource = a.distanceDurationFromSource ? a.distanceDurationFromSource.result.distance.value.toString() : "N/A";
            reportLine.Duration = a.totalDurationString;
            reportLine.PassengerDropOffTime = this.pickupType == CONSTANTS.PICKUP_TYPE_WORK ? moment(a.dropOffTime).format('dddd MMMM DD YYYY hh:mm A') : moment(this.getArrivalTimeRaw()).format('dddd MMMM DD YYYY hh:mm A');
            reportLine.PassengerDropOffTimeOnly = this.pickupType == CONSTANTS.PICKUP_TYPE_WORK ? moment(a.dropOffTime).format('hh:mm A') : moment(this.getArrivalTimeRaw()).format('hh:mm A');
            reportLine.Passenger = a.destinations[0].person;
            reportLine.PassengerAddress = a.address;
            reportLine.Department = a.department;

            reportLines.push(reportLine);
        });
        return reportLines;

    }


    /** Gets all areas with specified lat lng key */
    public getAreasByKey(latLngKey: string) {
        return this.areas.filter(x => x.getLatLngKey() == latLngKey);
    }

    public getAreaLegMapping(): Array<AreaLegMapping> {

        var counter = 0;
        var mapping = new Array<AreaLegMapping>();

        var counter = 0;
        this.legs.forEach(leg => {
            leg.routes["0"].waypoint_order.forEach(index => {
                var areaIndexMappedTo = this.areas[counter];
                var legAreaIsMappedTo = leg.routes["0"].legs[index];
                mapping.push(new AreaLegMapping(areaIndexMappedTo, legAreaIsMappedTo));
                counter++;
            });
        });

        return mapping;
    }


    static mergeTrips(trips: Array<Trip>): Array<Trip> {

        var merged = [];

        if (trips.length < 2) {
            return trips;
        }

        var accumilator: Trip = trips[0];
        for (var i = 1; i < trips.length; i++) {
            accumilator.addTrip(trips[i], true, false);
        }

        while (accumilator.areas.length != 0) {

            merged.push(accumilator.createNewTrip(SettingValues.maxTripSize));
        }

        return merged;
    }

    addTrip(trip: Trip, removeAreas = false, limit = false) {

        var count = 0;
        trip.areas.forEach(area => {

            if (limit) {

                if (this.areas.length < SettingValues.maxTripSize) {

                    count++;

                    if (removeAreas) {
                        this.areas.push(area);
                    } else {
                        this.areas.push(new Area(area.id, area.address, area.slotTime, area.destinations, area.centralPoint));
                    }
                }
            } else {
                count++;

                if (removeAreas) {
                    this.areas.push(area);
                } else {
                    this.areas.push(new Area(area.id, area.address, area.slotTime, area.destinations, area.centralPoint));
                }
            }

        });

        if (removeAreas) {
            trip.areas.splice(0, count);
        }
        this.passengers = this.getTotalPassengers();
    }
    addTrips(trips: Array<Trip>, ignoreMaxTripSize) {

        for (var i = 0; i < trips.length; i++) {
            var currentTrip = trips[i];
            if (currentTrip != this) {
                this.addTrip(currentTrip, false, !ignoreMaxTripSize);
            }
        }
    }

    removeTrip(trip: Trip) {

        var removedAreas = new Array<Area>();

        trip.areas.forEach(area => {
            var currentArea: Area;
            for (var i = 0; i < this.areas.length; i++) {

                currentArea = this.areas[i];

                if (currentArea.id == area.id) {
                    removedAreas.push(this.areas.splice(i, 1)[0]);
                    break;
                }
            }
        })

        this.passengers = this.getTotalPassengers();
        return removedAreas;
    }

    getSuitableReservation(trip: Trip, byCapacity = false): VehicleReservation {

        if (this.vehicleReservation != null) {

            if (trip.passengers.length <= (byCapacity ? this.vehicleReservation.vehicle.capacity : this.vehicleReservation.vehicle.remainingSeats)) {

                return this.vehicleReservation;
            } else {
                return null;
            }

        } else {
            return null;
        }
    }

    addPassengersFromTripToReservation(trip: Trip) {
        this.addTrip(trip);
        this.vehicleReservation.assignToNewTrip(trip);
    }

    createNewTrip(size: number): Trip {
        var newAreas = new Array<Area>();
        newAreas = this.areas.splice(0, size);
        this.passengers = this.getTotalPassengers();
        return new Trip(this.source, this.destination, newAreas, this.pickupType);
    }

    public static createTripsFromRawTripData(trips: Array<any>) {
        var solidTrips = new Array<Trip>();
        trips.forEach(t => {
            solidTrips.push(this.createTripFromRawTripData(t));
        })

        return solidTrips;
    }

    public static createTripFromRawTripData(trip) {
        var reservationJson = JSON.parse(JSON.stringify(trip.vehicleReservation));
        var res = new VehicleReservation(null);
        var newRes: VehicleReservation = Object.assign(res, reservationJson);

        var areas = JSON.parse(JSON.stringify(trip.areas));
        var realAreas = new Array<Area>();
        areas.forEach(a => {
            var realArea = new Area(a.id, a.address, a.slotTime, a.destinations, a.centralPoint);
            realAreas.push(Object.assign(realArea, a));
        })

        var t = new Trip(null, null, [], null);
        var copy = JSON.parse(JSON.stringify(trip));
        var newT: Trip = Object.assign(t, copy);
        newT.vehicleReservation = newRes;
        newT.areas = realAreas;
        newT.source = Area.createAreaFromJson(newT.source);
        newT.destination = Area.createAreaFromJson(newT.destination);

        if (trip.centralPoint) {

            var centralPoint = JSON.parse(JSON.stringify(trip.centralPoint));
            var realCentralPoint = new Area(centralPoint.id, centralPoint.address, centralPoint.slotTie, centralPoint.destinations, centralPoint.centralPoint);
            realCentralPoint = Object.assign(realCentralPoint, centralPoint);
            newT.centralPoint = realCentralPoint;
        }
        return newT;
    }

    copyTrip(): Trip {
        var reservationJson = JSON.parse(JSON.stringify(this.vehicleReservation));
        var res = new VehicleReservation(null);
        var newRes: VehicleReservation = Object.assign(res, reservationJson);

        var t = new Trip(null, null, [], null);
        var copy = JSON.parse(JSON.stringify(this));
        var newT: Trip = Object.assign(t, copy);
        newT.vehicleReservation = newRes;

        var realAreas: Array<Area> = [];
        newT.areas.forEach(a => {
            realAreas.push(Area.createAreaFromJson(a));
        });
        newT.areas = realAreas;
        return newT;
    }

    popArea(): Area {


        var area = this.areas.pop();
        this.passengers = this.getTotalPassengers();
        return area;

    }

    hasRemainingPassengers(): boolean {


        if (this.vehicleReservation == null) {

            return true;

        } else { // No vehicle allocated so passengers are remainig

            return false;
        }
    }

    getCentralPointTimeFromSource(directionsService: MapQuestDirectionsService, options: DirectionOptions): Promise<number> {

        return new Promise(async (resolve, reject) => {
            var centralTrip = new Trip(this.source, this.destination, [this.centralPoint], this.pickupType);
            await centralTrip.getDirections(directionsService, options).then(res => {

                resolve(res.time);
            }).catch(e => {
                reject(e);
            })
        })
    }

    public static getUniqueVehicles(trips: Array<Trip>): Array<Vehicle> {
        var vehicles = new Array<Vehicle>();
        trips.forEach(r => {
            if (!vehicles.find(v => v.vehicleid == r.vehicleReservation.vehicle.vehicleid)) {
                vehicles.push(r.vehicleReservation.vehicle);
            }
        });
        return vehicles;
    }


    public swap(source: Array<Area>, target: Array<Area>) {

        //1 Simple swap
        var firstInSource = source.splice(0, 1)[0];
        var firstInTarget = target.splice(0, 1)[0];
        var sourceIndex = this.areas.indexOf(firstInSource);
        var targetIndex = this.areas.indexOf(firstInTarget);
        this.swapIndex(sourceIndex, targetIndex);

        //2 Move remaining beside source
        this.moveAreasToTarget(source, firstInSource);

        //3 Move remaining besife target
        this.moveAreasToTarget(target, firstInTarget);

        //4 Reset the source if needed
        this.resetSource();
    }

    public moveAreasToTarget(areas: Array<Area>, target: Area, after = true) {
        areas.forEach(a => {
            this.areas.splice(this.areas.indexOf(a), 1);
        });
        this.areas.splice((this.areas.indexOf(target) + (after ? 1 : 0)), 0, ...areas);
    }

    public regroupAreas(areas: Array<Area>, target: Area, after = true) {
        //Regroup passengers so they stay together.
        var passengerGroup = [];
        areas.forEach(x => {
            var i = this.areas.indexOf(x);
            passengerGroup.push(this.areas.splice(i, 1)[0]);
        });

        //Insert the group after the newly re-located area 
        this.areas.splice((this.areas.indexOf(target) + (after ? 1 : 0)), 0, ...areas);
    }


    private swapIndex(x: number, y: number) {
        var temp = this.areas[y];
        this.areas[y] = this.areas[x];
        this.areas[x] = temp;
    }


    public move(source: Area, target: Area) {
        var x = this.areas.indexOf(source);
        var y = this.areas.indexOf(target);
        this.arraymove(x, y);
    }

    private arraymove(fromIndex, toIndex) {
        var element = this.areas[fromIndex];
        this.areas.splice(fromIndex, 1);
        this.areas.splice(toIndex, 0, element);
    }

    isBasicTrip() {
        if (this.companyid == -1 || this.locationid == -1) {
            return true;
        }
        return false;
    }



    updatePosition(sourceAreas: Array<Area>, targetPos) {
        //1. Correct target position
        targetPos = (targetPos - 1);
        var target: Area = null;
        //2. Get Passengers at target;
        var passengersAtTarget = this.getAreasByKey(this.areas[targetPos].getLatLngKey());

        //3. Decide if insert is after or before
        var after = true;
        if (this.areas.indexOf(passengersAtTarget[0]) < this.areas.indexOf(sourceAreas[0])) {
            after = false;
            target = passengersAtTarget[0];
        } else {
            after = true;
            target = passengersAtTarget[passengersAtTarget.length - 1];
        }

        //4. Move all passengers from the source to the target
        this.moveAreasToTarget(sourceAreas, target, after);

        //5. Re-group the target passengers
        //this.regroupAreas(passengersAtTarget,sourceAreas[sourceAreas.length-1],!after);
    }

    /** Add a passenger to the trip at a specific position */
    public async addPassengerAtIndex(areas: Array<Area>, index) {
        return new Promise((resolve, reject) => {
            if (this.hasSeats()) {
                this.areas.splice(index, 0, ...areas);
                this.passengers = this.getTotalPassengers();
                resolve(true)
            } else {
                reject('MAX_CAPACITY');
            }
        });
    }

    /**Upgrade the vehicle*/
    async upgradeContractVehicleSize(newSize: number) {
        if (Vehicle.isContracted(this.getVehicle())) {
            this.vehicleReservation.vehicle.capacity = newSize;
        } else {
            throw new Error("Only contracted/virtual vehicles can be have their size upgraded!");
        }
    }

    hasSeats(): boolean {
        var passengers = this.getTotalPassengers().length;
        if (this.vehicleReservation) {
            if (passengers < this.vehicleReservation.vehicle.capacity) {
                return true;
            } else {
                return false;
            }
        } else {
            if (passengers < this.maxCapacity) {
                return true;
            } else {
                return false;
            }
        }
    }

    public unloadPassenger(area: Area) {
        let index = this.loadedPassengers.indexOf(area);
        if (index >= 0) {
            this.loadedPassengers.splice(index, 1);
        }
    }

    public getAvailableSeats(): number {
        return (this.vehicleReservation.vehicle.capacity - this.loadedPassengers.length);
    }

    /** Find the most efficient place to add a new passenger to on the trip based on round trip time*/
    public async optimizePassengerPosition(area: Area, service: MainService) {
        if (this.hasSeats()) {
            let timeIndex = null;
            let count = this.areas.length;

            //Try all positions
            for (var i = 0; i < count; i++) {
                try {
                    await this.addPassengerAtIndex([area], i);
                    await this.calculateDirections(service);
                    if (!timeIndex) {
                        timeIndex = {
                            time: this.time,
                            index: i
                        }
                    } else if (this.time < timeIndex.time) {
                        timeIndex = {
                            time: this.time,
                            index: i
                        }
                    }
                    this.removePassenger(area);
                } catch (e) {
                    return null;
                }
            }
            return timeIndex;
        } else {
            return null;
        }
    }

    /** Add a passenger to the end of the trip */
    public addPassenger(area: Area) {
        if (this.hasSeats()) {
            this.areas.push(area);
            this.passengers = this.getTotalPassengers();
            return true;
        } else {
            return false;
        }
    }

    public loadPassenger(area: Area): boolean {
        if (this.loadedPassengers.length < this.vehicleReservation.vehicle.capacity) {
            this.loadedPassengers.push(area);
            return true;
        } else {
            return false;
        }
    }

    public removePassenger(area: Area) {
        var index = this.areas.indexOf(area);
        var t: Area = null;
        if (index >= 0) {
            t = this.areas.splice(index, 1)[0];
            this.passengers = this.getTotalPassengers();
            this.resetSource();
        }
        return t;
    }

    resetSource() {
        /*For home to work pickup we have to ensure that we are always setting
        the source of the trip to the first passenger
        */
        if (this.pickupType == CONSTANTS.PICKUP_TYPE_HOME) {
            if (this.areas.length > 0) {
                this.source = this.areas[0];
            } else {
                this.source = this.destination;
            }
        }
    }

    public removePassengers(areas: Array<Area>) {
        var passengers: Array<Area> = [];
        areas.forEach(a => {
            passengers.push(this.removePassenger(a));
        });
        return passengers;
    }




    /**** FUNCTIONS USED IN SIMULATION ****/

    /**
     * This get the planned time the trip should start not taking into account anything else
     * @returns 
     */
    getPlannedDepartTime() {
        return this.reportDate;
    }

    /**
     * This get the planned return time of the trip not taking into account anything else
     * @returns 
     */
    getPlannedReturnTime() {
        var mins = new UnitConverter().secondToMinute(this.time);
        if (mins > 60) {
            var hours = new UnitConverter().minuteToHours(mins);
            var decimalPortion = hours % 1;
            return Math.floor(hours) + "h " + Math.floor(decimalPortion * 60) + "m"
        } else {
            return Math.floor(mins) + "m";
        }
    }

}